export const resizeBase64Image = function (data, wantedWidth, wantedHeight) {
  return new Promise((resolve) => {
    // We create an image to receive the Data URI
    const img = document.createElement("img");
    // When the event "onload" is triggered we can resize the image.
    img.onload = function () {
      // We create a canvas and get its context.
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      // const wantedHeight =Math.ceil((wantedWidth*oldHeight)/oldWidth);
      // We set the dimensions at the wanted size.
      canvas.width = wantedWidth;
      canvas.height = wantedHeight;

      // We resize the image with the canvas method drawImage();
      ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

      const dataURI = canvas.toDataURL("image/jpeg", 0.5)// ('image/jpeg', 1.0);
      resolve(dataURI)
    };
    // We put the Data URI in the image's src attribute
    img.src = data;
  })
};


// WEBPACK FOOTER //
// ./src/helpers/images-methods.js